export default __webpack_public_path__ + "static/media/error-alert.93a47b4b.svg";